import React, { useEffect, useCallback } from 'react';
import CompanyRulesStyled from './CompanyRulesStyled';
// import { useTheme } from '@material-ui/styles';
import {
  // TextField,
  // Switch,
  FormControl,
  FormControlLabel,
  // FormHelperText,
  Radio,
  RadioGroup,
  // InputAdornment,
  useTheme,
  // Button,
  InputLabel,
  Box,
  FormLabel,
  Select,
  MenuItem,
  Chip,
} from '@material-ui/core';
import { Controller, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'dva';
import { useIntl } from 'umi';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, arr, theme) {
  return {
    fontWeight:
      arr.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
    color: '#000',
  };
}

export default (props) => {
  const theme = useTheme();
  const intl = useIntl();
  const { formatMessage } = intl;
  const {
    isAllCompany,
    setIsAllCompany,
    companies,
    setCompanies,
    dataId,
    opt,
  } = props;
  const dispatch = useDispatch();
  const { getValues, control, setValue } = useForm();

  useEffect(() => {
    if (dataId) {
      setValue('companies', companies);
    }
  }, [dataId]);

  // 获取公司接口
  const fetchData = useCallback(() => {
    dispatch({
      type: 'sceneMarketing/getCompanyList',
      payload: {
        values: {},
      },
    });
  }, [dispatch]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const companyList = useSelector((state) => state.sceneMarketing.companyList);

  return (
    <CompanyRulesStyled theme={theme}>
      <FormLabel component="legend" className="basic-cycle">
        <span className="label-require">*</span>
        {formatMessage({ id: 'marketing.scene.holiday.n07.lbl01' })}
      </FormLabel>
      <Box width="100%" mt={7.5}>
        <Box display="flex" className="company-wrap">
          <Controller
            render={(pr) => (
              <RadioGroup
                className="checkbox-radio-disabled-color"
                aria-label="couponUsingThreshold"
                onChange={(e) => {
                  setIsAllCompany(Boolean(e.target.value === 'true'));
                  return pr.onChange(e.target.value);
                }}
                disabled={opt === 'detail'}
                value={isAllCompany}
                // value={isAllCompanyState ?? deIsAllCompanyState}
              >
                <Box display="flex" gridGap="0 53px">
                  <Box display="flex" mr={11}>
                    <FormControlLabel
                      variant="standard"
                      value={true}
                      control={<Radio disabled={opt === 'detail'} />}
                      label={
                        <Box color="#000" lineHeight="1">
                          {/* 全部公司 */}
                          {formatMessage({
                            id: 'marketing.scene.holiday.n07.rdo02',
                          })}
                        </Box>
                      }
                      // disabled={queryType === 'detail'}
                    />
                  </Box>
                  <Box>
                    <FormControlLabel
                      variant="standard"
                      value={false}
                      control={<Radio disabled={opt === 'detail'} />}
                      label={
                        <Box color="#000" lineHeight="1">
                          {/* 指定公司 */}
                          {formatMessage({
                            id: 'marketing.scene.holiday.n07.rdo03',
                          })}
                        </Box>
                      }
                      // disabled={queryType === 'detail'}
                    />
                  </Box>
                </Box>
              </RadioGroup>
            )}
            control={control}
            name="isAllCompany"
            rules={{
              validate: () => {
                if (
                  getValues('isAllCompany') === 'false' &&
                  getValues('companies').length === 0
                ) {
                  return false;
                }
                return true;
              },
            }}
          />
          <Box>
            <Controller
              // className="multiple-select"
              render={(pr) => (
                <FormControl
                  sx={{ m: 1, width: 540 }}
                  variant="standard"
                  // className="multiple-wrap-style"
                  className="multiple-select"
                  disabled={isAllCompany || opt === 'detail'}
                >
                  <InputLabel id="demo-multiple-chip-label">
                    {/* 公司名称 */}
                    {formatMessage({ id: 'marketing.scene.holiday.n07.rdo04' })}
                  </InputLabel>
                  <Select
                    labelId="demo-multiple-chip-label"
                    id="demo-multiple-chip"
                    multiple
                    value={companies}
                    // value={companyId || deCompanyId}
                    onChange={(e) => {
                      const value = e.target.value;
                      setCompanies(
                        typeof value === 'string' ? value.split(',') : value,
                      );
                      return pr.onChange(e.target.value);
                    }}
                    renderValue={(selected) => {
                      return Array.isArray(selected) && selected.length > 0 ? (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                          {selected.map((value) => (
                            <Chip
                              key={value}
                              label={(() => {
                                const data = companyList?.find(
                                  (item) => item.id === value,
                                );
                                return <>{data?.name}</>;
                              })()}
                              sx={{ m: '2px' }}
                            />
                          ))}
                        </Box>
                      ) : (
                        ''
                      );
                    }}
                    MenuProps={MenuProps}
                  >
                    {Array.isArray(companyList) &&
                      companyList.length > 0 &&
                      companyList.map((data) => (
                        <MenuItem
                          key={data.id}
                          value={data.id}
                          style={getStyles(data.id, companies, theme)}
                        >
                          {data?.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              )}
              control={control}
              name="companies"
            />
            {/* {(isAllCompanyState ?? deIsAllCompanyState) ===
                          'false' &&
                        companyId.length === 0 &&
                        deCompanyId.length === 0 ? (
                          <Box className="input-error-style">
                            {errors.isAllCompany ? '请选择公司' : ''}
                          </Box>
                        ) : (
                          ''
                        )} */}
          </Box>
        </Box>
      </Box>
    </CompanyRulesStyled>
  );
};
